import React from 'react';

export default function ArchiveRemoveIcon() {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.9995 8.74999C11.5895 8.74999 11.2495 8.40999 11.2495 7.99999V3.80999L10.5295 4.52999C10.2395 4.81999 9.75945 4.81999 9.46945 4.52999C9.17945 4.23999 9.17945 3.75999 9.46945 3.46999L11.4695 1.46999C11.6795 1.25999 12.0095 1.18999 12.2895 1.30999C12.5695 1.41999 12.7495 1.69999 12.7495 1.99999V7.99999C12.7495 8.40999 12.4095 8.74999 11.9995 8.74999Z"
                fill="currentColor"
            />
            <path
                d="M13.9995 4.74994C13.8095 4.74994 13.6195 4.67994 13.4695 4.52994L11.4695 2.52994C11.1795 2.23994 11.1795 1.75994 11.4695 1.46994C11.7595 1.17994 12.2395 1.17994 12.5295 1.46994L14.5295 3.46994C14.8195 3.75994 14.8195 4.23994 14.5295 4.52994C14.3795 4.67994 14.1895 4.74994 13.9995 4.74994Z"
                fill="currentColor"
            />
            <path
                d="M16 22.75H8C2.25 22.75 2.25 19.7 2.25 17V16C2.25 13.77 2.25 11.25 7 11.25C8.19 11.25 8.63 11.54 9.25 12C9.28 12.03 9.32 12.05 9.35 12.09L10.37 13.17C11.23 14.08 12.79 14.08 13.65 13.17L14.67 12.09C14.7 12.06 14.73 12.03 14.77 12C15.39 11.53 15.83 11.25 17.02 11.25C21.77 11.25 21.77 13.77 21.77 16V17C21.75 20.82 19.82 22.75 16 22.75ZM7 12.75C3.75 12.75 3.75 13.77 3.75 16V17C3.75 19.74 3.75 21.25 8 21.25H16C18.98 21.25 20.25 19.98 20.25 17V16C20.25 13.77 20.25 12.75 17 12.75C16.28 12.75 16.13 12.84 15.7 13.16L14.73 14.19C14.01 14.95 13.04 15.37 12 15.37C10.96 15.37 9.99 14.95 9.27 14.19L8.3 13.16C7.87 12.84 7.72 12.75 7 12.75Z"
                fill="currentColor"
            />
            <path
                d="M5 12.7502C4.59 12.7502 4.25 12.4102 4.25 12.0002V10.0002C4.25 8.06022 4.25 5.65022 7.93 5.30022C8.33 5.25022 8.71 5.56022 8.75 5.98022C8.79 6.39022 8.49 6.76022 8.07 6.80022C5.75 7.01022 5.75 7.95022 5.75 10.0002V12.0002C5.75 12.4102 5.41 12.7502 5 12.7502Z"
                fill="currentColor"
            />
            <path
                d="M18.9994 12.7502C18.5894 12.7502 18.2494 12.4102 18.2494 12.0002V10.0002C18.2494 7.95022 18.2494 7.01022 15.9294 6.79022C15.5194 6.75022 15.2194 6.38022 15.2594 5.97022C15.2994 5.56022 15.6594 5.25022 16.0794 5.30022C19.7594 5.65022 19.7594 8.06022 19.7594 10.0002V12.0002C19.7494 12.4102 19.4094 12.7502 18.9994 12.7502Z"
                fill="currentColor"
            />
        </svg>
    );
}
